import React from 'react';

const LoadingPage = () => (
  <div className="loader-container">
    <div className="loader"></div>
  </div>
);

export default LoadingPage;
